import type { PolicyId } from '@/modules/admin/cost-objects/types'

export function getEcomPolicyIdList(policyIds: string): PolicyId[] {
  if (!policyIds) return ['no-policy' as const]
  return policyIds.split(',').map(Number)
}
